import { useEffect, useState } from 'react'

import * as S from './styles'

import CodeField from './CodeField'

import AlertPopover from '../ui/AlertPopover'
import ButtonDefault from '../ui/Buttons/ButtonDefault'
import ButtonPrimary from '../ui/Buttons/ButtonPrimary'
import ModalDefault from '../ui/Modals/ModalDefault'

function TwoStepVerification(props) {
  const [responseType, setResponseType] = useState(undefined)
  const [popoverActive, setPopoverActive] = useState(false)
  const [code, setCode] = useState('')

  async function handleConfirmationCode() {
    const response = await props.handleConfirmationCode(code)

    if (response === 'success') {
      setPopoverActive(false)
      setResponseType('success')
    } else if (response === 'error') {
      setPopoverActive(true)
      setResponseType('error')
    }
  }

  useEffect(() => {
    if (responseType !== 'success') {
      setResponseType(popoverActive ? 'error' : null)
    }
  }, [popoverActive])

  useEffect(() => {
    if (props.active) {
      setPopoverActive(false)
      setResponseType(undefined)
    }
  }, [props.active])

  return (
    <ModalDefault
      active={props.active}
      title='Verificação em duas etapas'
      onClick={() => props.setVerificationModalActive(false)}
      noButtonClose={props.noButtonClose}
    >
      <p>
        Utilize o código gerado no Google Authenticator.
      </p>

      <S.Space />

      <S.FlexContainerBetween>
        <S.HighlightText>
          Digite o código de verificação
        </S.HighlightText>
      </S.FlexContainerBetween>

      <S.Space />

      <S.CodeContainer>
        {props.active &&
          <CodeField
            responseType={responseType}
            setValue={(value) => setCode(value)}
            confirmCode={handleConfirmationCode}
          />
        }

        <S.PopoverContainer>
          <AlertPopover
            title='O código inserido não é válido'
            type='danger'
            position='bottom'
            active={popoverActive}
          />
        </S.PopoverContainer>
      </S.CodeContainer>

      <S.FlexContainer>
        {!props.noButtonClose &&
          <S.ButtonContainer>
            <ButtonDefault
              upperCase
              size='md'
              text='Cancelar'
              disabled={responseType === 'success'}
              onClick={() => props.setVerificationModalActive(false)}
            />
          </S.ButtonContainer>
        }

        <S.ButtonContainer>
          <ButtonPrimary
            upperCase
            size='md'
            text='Confirmar'
            disabled={responseType === 'success' || code.length < 6}
            onClick={handleConfirmationCode}
          />
        </S.ButtonContainer>

      </S.FlexContainer>

    </ModalDefault>
  )
}

export default TwoStepVerification
